import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ServiceUsersFormErrorStatesEnum {
    GetUserSettingsFailed = ErrorStateScheduleEnum.ServiceUsersFormStatesStartIndex,
}
